// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__W1lMB","prefix":"styles_prefix__jrh96","postfix":"styles_postfix__xQIbX"};